import { render } from "./statistics_filter.vue?vue&type=template&id=c06ecd3e"
import script from "./statistics_filter.vue?vue&type=script&lang=js"
export * from "./statistics_filter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__